/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Preferences_Page_TitleInputs */

const de_notifications_preferences_page_title = /** @type {(inputs: Notifications_Preferences_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

/** @type {(inputs: Notifications_Preferences_Page_TitleInputs) => LocalizedString} */
const en_notifications_preferences_page_title = de_notifications_preferences_page_title;

/**

* @param {Notifications_Preferences_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_page_title = /** @type {((inputs?: Notifications_Preferences_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_page_title(inputs)
	return en_notifications_preferences_page_title(inputs)
});